<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-center py-4">
                        <div class="col-lg-6 col-md-6 col-2 mb-3">
                        <h2>Wealthscape</h2>
                        </div>
                        <div class="col-lg-6 col-6 text-right">
                            <form class="form-inline justify-content-end">
                                <div class="form-group col-auto mr-01">
                                    <input type="text" placeholder="Enter New Repcode" v-model="newRepCode" class="form-control"/>                                    
                                </div>
                                <button :disabled="!newRepCode"  type="button" @click="addRepCode()" class="btn btn-success rounded">ADD REPCODE</button>
                            </form>                                    
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="col-auto mt-3 justify-content-start welthscape" style="display:inline-flex">
                            <div class="form-group col-md-2">
                                <label for="filter">Settlement Date</label>
                                <datepicker  @selected="dateSelected()" v-model="selectedDate"  name="fromDate" format="yyyy/MM/dd" :clear-button="false" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                            </div>
                    
                            <div class="form-group" v-for="field in extraFields" :key="field.extraFieldId">
                                <label for="filter">{{field.fieldName}}</label>
                                <input type="number" :disabled="field.fieldName == 'Outside Off-Board'" v-model="field.assignedValue" class="form-control" placeholder="0.00">
                            </div>
                             <div class="form-group">
                                <label for="filter"></label>
                                <button :disabled="!selectedDate" v-if="welthScapeIsAdd" @click="saveExtraFileds()" type="button"  class="btn btn-primary rounded">SAVE</button>
                                <button :disabled="!selectedDate" v-if="!welthScapeIsAdd" @click="updateExtraFileds()" type="button"  class="btn btn-primary rounded">SAVE</button>
                            </div>
                        </div>  
                          
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort col-md-6"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'traderId'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'traderId'  ? 'sort-desc' : '']"  
                                    @click="sort('traderId')" >REPCODE</th> 
                                <th 
                                    scope="col" 
                                    class="sort col-md-3"
                                     >{{assignedDate}}</th> 
                                <th 
                                    scope="col" 
                                    class="sort col-md-3"
                                     >OUTSIDE OFF-BOARD</th> 
                                <th 
                                    scope="col" 
                                    class="sort col-md-3 text-center"
                                     >STATUS</th>         
                                <th 
                                    scope="col col-md-3" 
                                    class="text-center">Action</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="repCodes.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="repCode in repCodes" :key="repCode.id" >
                                <td>{{repCode.repCode}}</td>
                                <td>
                                  <input :disabled="repCode.repcodeStatus == 'INACTIVE'"  type="number" class="form-control" v-model="repCode.assignedValue" >
                                </td>
                                <td>
                                    <input :disabled="repCode.repcodeStatus == 'INACTIVE'"  type="number" class="form-control" v-model="repCode.outsideOffBoard" >
                                    
                                </td>
                                <td class="text-center"><span class="badge" v-bind:class="repCode.repcodeStatus == 'ACTIVE' ? 'active' : 'deactive'">{{repCode.repcodeStatus == 'ACTIVE' ? 'ACTIVE' : 'INACTIVE'}}</span></td>

                                <td class="text-center">
                                    <div class="d-inline-flex"> 
                                        <!-- <a @click="saveWelthScapeData(repCode)" title="SAVE" class="btn ibtn grn">SAVE</a> -->
                                        <button :disabled="!repCode.assignedValue"  @click="saveWelthScapeData(repCode)" type="button"  class="btn btn-primary rounded">SAVE</button>
                                        <!-- <a  @click="deleteRepCode(repCode)" class="btn ibtn btn-outline-danger"><i class="fas fa-trash-alt"></i></a> -->
                                        <button @click="deleteRepCode(repCode)" v-if="repCode.repcodeStatus == 'ACTIVE'" type="button" class="btn btn-danger"> DEACTIVATE</button>
                                        <button @click="deleteRepCode(repCode)" v-if="repCode.repcodeStatus == 'INACTIVE'" type="button" class="btn btn-primary" >ACTIVATE</button>
                                    </div>  
                                </td>
                            </tr>    
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <!-- <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getTraderList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div> -->
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "ImsProfitLossRepCode.vue",
   components: {
        Datepicker
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "id",
        sortOrder: "DESC",
        repCodes : [],
        selectedDate : null,
        assignedDate : null,
        newRepCode : null,
        extraFields : [
                        {
                            "extraFieldId": 1,
                            "fieldName": "Account Balance",
                            "assignedDate": "",
                            "assignedValue": ""
                        },
                        {
                            "extraFieldId": 2,
                            "fieldName": "EOD Sales Credit",
                            "assignedDate": "",
                            "assignedValue": ""
                        },
                        {
                            "extraFieldId": 3,
                            "fieldName": "Wealthscape Daily Sales Credit",
                            "assignedDate": "",
                            "assignedValue": ""
                        },
                        {
                            "extraFieldId": 4,
                            "fieldName": "Outside Off-Board",
                            "assignedDate": "",
                            "assignedValue": ""
                        }
                    ],
        welthScapeIsAdd : true                
        };
  },
  methods: {
        saveExtraFileds(){
            if(this.checkValid()){
                this.loading = true;
                var dataToSend = [];
                this.extraFields.forEach(obj => {
                    let welthdata = {};
                        welthdata.extraFieldId = obj.extraFieldId;
                        welthdata.assignedDate = this.moment(this.selectedDate).format("YYYY-MM-DD") 
                        welthdata.assignedValue = obj.assignedValue;
                    dataToSend.push(welthdata)
                });
                console.log(dataToSend)
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .post(config.baseUrlBidSide + "/pnl/extra-field-daily", dataToSend, auth)
                .then(() => {
                    this.loading = false;
                    this.$alert("Wealthscape data added Successfully.","","success"); 
                    this.getExtraFields();           
                })
                .catch(() => {
                    this.loading = false;              
                }); 
            }
        },
        updateExtraFileds(){
            if(this.checkValid()){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .put(config.baseUrlBidSide + "/pnl/extra-field-daily-update", this.extraFields, auth)
                .then(() => {
                    this.loading = false;
                    this.$alert("Wealthscape data updated Successfully.","","success");  
                    this.getExtraFields();         
                })
                .catch(() => {
                    this.loading = false;              
                }); 
            }
        },
        checkValid(){
            let returnFlag = true;
            let self = this;
            this.extraFields.forEach(data => {
                if(!data.assignedValue && data.extraFieldId != 4){
                    returnFlag = false;
                    self.$alert(data.fieldName+" is required","","error");
                }
            });
            return returnFlag;
        },
        clearWelthscapeData(){
          this.extraFields =   [
                        {
                            "extraFieldId": 1,
                            "fieldName": "Account Balance",
                            "assignedDate": "",
                            "assignedValue": ""
                        },
                        {
                            "extraFieldId": 2,
                            "fieldName": "EOD Sales Credit",
                            "assignedDate": "",
                            "assignedValue": ""
                        },
                        {
                            "extraFieldId": 3,
                            "fieldName": "Wealthscape Daily Sales Credit",
                            "assignedDate": "",
                            "assignedValue": ""
                        },
                        {
                            "extraFieldId": 4,
                            "fieldName": "Outside Off-Board",
                            "assignedDate": "",
                            "assignedValue": ""
                        }]

        },
        getExtraFields(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            let fDate = this.moment(this.selectedDate).format("YYYY-MM-DD") 
            let tDate = this.moment(this.selectedDate).add('days', 1).format("YYYY-MM-DD")
            this.$http
            .get(config.baseUrlBidSide + 
                "/pnl/extra-field-daily-list" +
                "?fromDate="+
                fDate+
                "&toDate="+
                tDate,
                auth
            )
            .then((result) => {
                this.loading = false;
                if(result.data.length > 0){
                    this.extraFields = result.data;
                    this.welthScapeIsAdd = false;
                }else{
                    this.welthScapeIsAdd = true;
                } 
                                     
            })
            .catch(() => {
                this.loading = false;              
            });
        },
        dateSelected(){
            setTimeout(() => {
                this.getRepCodeList();
                this.clearWelthscapeData();
                this.getExtraFields();
            },500);
        },
        getRepCodeList(currentPage){
            if (!currentPage) {
                currentPage = 1;
            }
            if(!this.selectedDate){
                return;
            }   
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            let fDate = this.moment(this.selectedDate).format("YYYY-MM-DD") 
            let tDate = this.moment(this.selectedDate).add('days', 1).format("YYYY-MM-DD")
            this.$http
            .get(config.baseUrlBidSide + 
                "/pnl/rep-code-daily-list" +
                "?fromDate="+
                fDate+
                "&toDate="+
                tDate,
                auth
            )
            .then((result) => {
                this.repCodes = result.data;
                this.loading = false; 
                this.assignedDate = fDate;
                this.repCodes.forEach((data) => {
                    data.edit = false
                })                         
            })
            .catch(() => {
                this.loading = false;              
            });
    },
    addRepCode(){
        this.loading = true;
        var data = { "repCodes":[this.newRepCode]}
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .post(config.baseUrlBidSide + "/pnl/rep-code", data, auth)
        .then(() => {
            this.loading = false;
            this.newRepCode = null;
            this.$alert("Rep code added Successfully.","","success");
            this.getRepCodeList();              
        })
        .catch(() => {
            this.loading = false;              
        });  
    },
    saveWelthScapeData(repCode){
        console.log(repCode);
        if(repCode.assignedValue){
            if(repCode.id){
                this.updateWelthScapeData(repCode);
            }else{
                this.addWelthScapeData(repCode);
            }         
        }
    },
    addWelthScapeData(repCode){
        this.loading = true;
        var data = {
            "repCodeId":repCode.repCodeId,
            "assignedDate":this.assignedDate,
            "assignedValue":repCode.assignedValue,
            "outsideOffBoard" : repCode.outsideOffBoard
        }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .post(config.baseUrlBidSide + "/pnl/rep-code-daily", data, auth)
        .then(() => {
            this.loading = false;         
            this.getRepCodeList();
            this.$alert("Updated Successfully.","","success");
        })
        .catch(() => {
            this.loading = false;              
        });  
    },
    updateWelthScapeData(repCode){
        this.loading = true;
        // var data = {"repCodeId":repCode.repCodeId,"assignedDate":this.assignedDate,"assignedValue":repCode.assignedValue};
         var data = {
            "id":repCode.id,
            "assignedDate":this.assignedDate,
            "assignedValue":repCode.assignedValue,
            "outsideOffBoard" : repCode.outsideOffBoard

        }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .put(config.baseUrlBidSide + "/pnl/rep-code-daily-update", data, auth)
        .then(() => {
            this.loading = false;         
            this.getRepCodeList();
            this.$alert("Updated Successfully.","","success");
        })
        .catch(() => {
            this.loading = false;              
        });  
    },
    deleteRepCode(repcode){
        var status = repcode.repcodeStatus == 'ACTIVE' ? 'deactivate' : 'activate';

        var message = "Are you sure you want to "+status+ " this repcode?";
        this.$confirm(message,"","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            var data =  {"id":repcode.id,"repCodeId" : repcode.repCodeId ,"status":repcode.repcodeStatus == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'}
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .put(config.baseUrlBidSide + "/pnl/rep-code-daily-update", data, auth)
            .then(() => {
                this.loading = false;              
                this.getRepCodeList();
                let msg = "Repcode "+status+ "d successfully";
                this.$alert(msg,"","success");

            })
            .catch(() => {
                this.loading = false;              
            });
        });
    }
    
  },
  mounted() {
      this.selectedDate = this.moment().format();
      this.assignedDate = this.moment().format("MM-DD-YYYY");
      this.getRepCodeList();
      this.getExtraFields();

   
  }
};
</script>

<style scoped>
.welthscape input{
    font-size: 12px;
    height: 38px;
}
</style>